import { Controller } from "@hotwired/stimulus"

// When the section scrolls into view, the copy rises in and the planholder rows
// fade in top-to-bottom (staggered). Replays on re-entry. Static for reduced motion.
export default class extends Controller {
  static targets = ["intro", "row"]

  connect() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return

    this.introRevealed = false
    this.active = false
    this.rowTargets.forEach((row) => (row.style.opacity = "0"))
    this.introTargets.forEach((intro) => (intro.style.opacity = "0"))

    this.observer = new IntersectionObserver(
      (entries) => {
        const visible = entries.some((entry) => entry.isIntersecting)
        if (visible && !this.active) {
          this.active = true
          this.reveal()
        } else if (!visible && this.active) {
          this.active = false
        }
      },
      { threshold: 0.15 }
    )
    this.observer.observe(this.element)
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
  }

  reveal() {
    if (!this.introRevealed) {
      this.introRevealed = true
      this.introTargets.forEach((intro) => {
        intro.animate(
          [{ opacity: 0, transform: "translateY(12px)" }, { opacity: 1, transform: "translateY(0)" }],
          { duration: 600, easing: "cubic-bezier(0.22, 1, 0.36, 1)", fill: "both" }
        )
      })
    } else {
      this.introTargets.forEach((intro) => (intro.style.opacity = "1"))
    }

    this.rowTargets.forEach((row, i) => {
      row.style.opacity = "0"
      const animation = row.animate(
        [{ opacity: 0, transform: "translateY(8px)" }, { opacity: 1, transform: "translateY(0)" }],
        { duration: 300, delay: i * 70, easing: "cubic-bezier(0.22, 1, 0.36, 1)", fill: "both" }
      )
      animation.onfinish = () => {
        row.style.opacity = "1"
        animation.cancel()
      }
    })
  }
}
